import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import PageSectionHeading from '../../PageSectionHeading';
import { colors } from '../../../styles';

const styles = css`
  padding: 90px 0;
  position: relative;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: ${colors.black};
  }
  @media (min-width: 992px) {
    padding: 110px 0 140px 0;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
    &::before {
      display: none;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;
      background-color: ${colors.black};
      opacity: .7;
    }
  }
  .container {
    z-index: 3;
    position: relative;
  }
  .PhotoList_list {
    list-style: none;
    display: flex;
    margin: 0 -15px;
    padding: 0;
    flex-flow: row wrap;
    justify-content: center;
    transition: all .3s ease-out;
    position: relative;
    z-index: 4;
    @media (min-width: 992px) {
      margin: 0;
    }
  }
  .PhotoList_item {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 50%;
    overflow: hidden;
    transition: all .3s ease-out;
    @media (min-width: 992px) {
      width: 33.333%;
    }
    a {
      position: relative;
      display: block;
      &:focus, &:hover {
        .PhotoList_image {
          transform: scale(1.1);
          transition: all .3s ease-out;
        }
        .PhotoList_imageTitle::before {
          content:'';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: ${colors.brand2};
          opacity: .85;
          position: absolute;
          display: block;
          z-index: -2;
          opacity: .8;
        }
      }
    }
  }
  .PhotoList_imageTitle {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: 1;
    text-align: center;
    transition: all .5s ease;
    font-weight: 700;
    font-size: 15px;
    line-height: 2;
    color: ${colors.white};
    z-index: 2;
    @media (min-width: 992px) {
      font-size: 24px;
    }
    &::before {
      content:'';
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: ${colors.black};
      position: absolute;
      display: block;
      z-index: -2;
      opacity: .3;
      transition: all .3s ease;
    }
  }
  .PhotoList_image {
    position: relative;
    z-index: 0;
    width: 100%;
    padding-top: 56.25%;
    background-size: cover;
    background-position: center center;
    z-index: 1;
    transition: all .3s ease-out;
  }
`;

function PhotoGalleryBanner({ page }) {
  return (
    <div>
      {
        get(page, 'photo_gallery', []).length > 0 &&
        <div className={styles} style={{ backgroundImage: `url(${buildThumbnailUrl(get(page, 'page_image.contentUrl'), { width: 2000, height: 2000 })})` }}>
          <div className="container">
            <PageSectionHeading h3="Photo Gallery" className="text-white" />
            <ul className="PhotoList_list">
              {
                get(page, 'photo_gallery').map(item => (
                  <li className="PhotoList_item" key={item._id} >
                    <Link name="photo-gallery" params={{ gallery: item.category_name }}>
                      <div style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'category_photos[0].contentUrl'), { width: 800, height: 800 })})` }} className="PhotoList_image" />
                      <span className="PhotoList_imageTitle">
                        {item.category_name}
                        <img src="/images/icon-arrow-right-white.svg" alt="" />
                      </span>
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      }
    </div>
  );
}

PhotoGalleryBanner.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'photo_gallery',
  },
)(PhotoGalleryBanner);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PhotoGalleryBanner.section.js